import React from 'react';
import Modal from '../modal';
import BasicInformationSection from './BasicInformationSection';
import ConfigurationSection from './ConfigurationSection';
import ModulesSection from './ModulesSection';
import InvoiceStatusSection from './InvoiceStatusSection';
import TaxLabelsSection from './TaxLabelsSection';
import InvoiceExporterSection from './InvoiceExporterSection';
import UnitOfficeSection from './UnitOfficeSection';
import LogoSection from './LogoSection';

const ClientForm = ({ 
    showClientModal, 
    updatedClient, 
    components, 
    invoiceStatuses,
    data, 
    onCancel, 
    onSubmit, 
    updateField, 
    updateUnit, 
    removeUnit, 
    addUnit, 
    toggleFrontendSection, 
    toggleInvoiceStatus, 
    setInvoiceStatuses,
    updateVariance, 
    updateCostType, 
    updateCostTypeNIN, 
    updateLogo, 
    toggleExporterOption, 
    changeExporterValues, 
    changeColAmountExporter, 
    getInvoiceExporterOption, 
    getColumnValueExporter, 
    getHardCodedValueExporter, 
    changeColumnValueExporter,
    toggleModuleOption,
    addDefaultImputations,
    reviewSeedPromptAnswered,
    markReviewSeedPromptAnswered,
    requiredExpenseFields,
    setExpenseFieldRequired,
    reviewMode,
    setExpenseReviewMode
}) => {
    if (!showClientModal) return null;

    return (
        <form method="post" onSubmit={onSubmit}>
            <Modal width="60vw" title={updatedClient.name || data.t.read("add_client")}
                okIsSubmit={true} cancelAction={onCancel}
                okText={data.t.read("save")}
                cancelText={data.t.read("cancel")}>
                <BasicInformationSection 
                    updatedClient={updatedClient}
                    data={data}
                    updateField={updateField}
                />
                <ConfigurationSection
                    updatedClient={updatedClient}
                    components={components}
                    data={data}
                    updateField={updateField}
                    toggleFrontendSection={toggleFrontendSection}
                    updateVariance={updateVariance}
                    updateCostType={updateCostType}
                    updateCostTypeNIN={updateCostTypeNIN}
                />
                <ModulesSection 
                    data={data}
                    updatedClient={updatedClient}
                    components={components}
                    toggleFrontendSection={toggleFrontendSection}
                    toggleModuleOption={toggleModuleOption}
                    addDefaultImputations={addDefaultImputations}
                    reviewSeedPromptAnswered={reviewSeedPromptAnswered}
                    markReviewSeedPromptAnswered={markReviewSeedPromptAnswered}
                    requiredExpenseFields={requiredExpenseFields}
                    setExpenseFieldRequired={setExpenseFieldRequired}
                    reviewMode={reviewMode}
                    setExpenseReviewMode={setExpenseReviewMode}
                />
                <InvoiceStatusSection 
                    data={data}
                    updatedClient={updatedClient}
                    invoiceStatuses={invoiceStatuses}
                    setInvoiceStatuses={setInvoiceStatuses}
                />
                <TaxLabelsSection 
                    updatedClient={updatedClient}
                    data={data}
                    updateField={updateField}
                />
                <InvoiceExporterSection 
                    updatedClient={updatedClient}
                    data={data}
                    toggleExporterOption={toggleExporterOption}
                    changeExporterValues={changeExporterValues}
                    changeColAmountExporter={changeColAmountExporter}
                    getInvoiceExporterOption={getInvoiceExporterOption}
                    getColumnValueExporter={getColumnValueExporter}
                    getHardCodedValueExporter={getHardCodedValueExporter}
                    changeColumnValueExporter={changeColumnValueExporter}
                />
                <UnitOfficeSection 
                    updatedClient={updatedClient}
                    data={data}
                    updateUnit={updateUnit}
                    removeUnit={removeUnit}
                    addUnit={addUnit}
                />
                <LogoSection
                    updatedClient={updatedClient}
                    data={data}
                    updateLogo={updateLogo}
                />
            </Modal>
        </form>
    );
};

export default ClientForm;
